import { render, staticRenderFns } from "./EducationalStageInfo.vue?vue&type=template&id=ba59c240&"
import script from "./EducationalStageInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalStageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports